/* unplugin-vue-components disabled */import { render } from "./ip-whitelist.vue?vue&type=template&id=a549373c&scoped=true"
import script from "./ip-whitelist.vue?vue&type=script&setup=true&lang=js"
export * from "./ip-whitelist.vue?vue&type=script&setup=true&lang=js"

import "./ip-whitelist.vue?vue&type=style&index=0&id=a549373c&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a549373c"],['__file',"src/pages/settings/superuser/ip-whitelist.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a549373c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a549373c', __exports__)) {
    api.reload('a549373c', __exports__)
  }
  
  module.hot.accept("./ip-whitelist.vue?vue&type=template&id=a549373c&scoped=true", () => {
    api.rerender('a549373c', render)
  })

}


export default __exports__